import { Component, OnInit } from '@angular/core';
import { MenuManagementService } from '../services/menu-management.service';

@Component({
  selector: 'app-new-layers',
  templateUrl: './new-layers.component.html',
  styleUrls: ['./new-layers.component.scss'],
  standalone: false
})
export class NewLayersComponent implements OnInit {

  constructor(
    public menuService: MenuManagementService,
  ) { }

  ngOnInit(): void {
  }

}
